import { createFileRoute } from "@tanstack/react-router";
import { DailyStreakWidget } from "@/components/streak/DailyStreakWidget";
import { TopStreaksLeaderboard } from "@/components/streak/TopStreaksLeaderboard";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { ChallengeFriendButton } from "@/components/challenges/ChallengeFriendButton";

export const Route = createFileRoute("/racha")({
  head: () => ({
    meta: [
      { title: "Racha diaria · VerseSport" },
      { name: "description", content: "Reclama tu recompensa diaria, mantén tu racha durante el Mundial 2026 y desbloquea el badge World Cup Committed Fan." },
    ],
  }),
  component: RachaPage,
});

function RachaPage() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-background">
      <RouteTopBar fallback="/" />
      <div className="mx-auto w-full max-w-2xl space-y-4 px-3 py-6 sm:px-6">
        <DailyStreakWidget />
        <div className="flex items-center justify-between gap-3 rounded-2xl border border-border bg-background/60 p-3">
          <div className="min-w-0">
            <div className="text-sm font-black">⚔️ Reta a un amigo</div>
            <div className="truncate text-[11px] text-muted-foreground">Duelo privado de 24 h · +100 XP al ganador</div>
          </div>
          <ChallengeFriendButton />
        </div>
        <TopStreaksLeaderboard />
      </div>
    </main>
  );
}